<app-dialog
    header="Create Compound"
    [show]="true"
    [hasControls]="true"
    [minWidth]="1200"
    [maxWidth]="1200"
    saveBtnText="Create"
    [hideControlsDivider]="true"
    [hideHeaderUnderline]="true"
    (save)="submitForm()"
    (onSubmitKeyDown)="focusInput(name)"
    (cancel)="cancel.emit()"
    (onCancelKeyDown)="focusInput(name)"
    #dialog
>
    <div [formGroup]="form" class="component-container">
        <div class="compound-name-container">
            Compound Name on the platform:
            <span class="font-semibold">
                {{form.controls.name?.value}} {{form.controls.dose?.value}} {{form.controls.dosageUnit?.value?.name}} {{form.controls.dosageForm?.value?.name}}
            </span> 
        </div>
        <div class="flex space-x-4">
            <app-input class="name"
                label="Compound Name"
                formControlName="name"
                placeholder="Oral Vancomycin"
                [symbolsLeftCounter]="true"
                [maxLength]="100"
                [autofocus]="true"
                #name
            ></app-input>
            <app-datepicker-input [tabInd]="0"
                label="Transaction Date/Time"
                pickerType="both"
                formControlName="transactionDateDisplayValue"
                (dateTimeChange)="dateTimeChanged($event)"
                [dateMax]="now()"
                calendarPosition="right"
                (inputTabKeyDown)="focusInput(dose)"
                #transactionDatePicker>
            </app-datepicker-input>
        </div>
        <div class="flex space-x-4">
            <app-input 
                label="Dose"
                formControlName="dose"
                [ignoreInput]="true"
                [allowedSymbols]="['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '.', '/', ' ', '-']"
                placeholder="250 / 5"
                (keydownTab)="dosageUnit.focus()"
                #dose
            ></app-input>
            <app-autocomplete class="autocomplete"
                [data]="dosageUnits$ | async" 
                searchKeyword="name"
                [control]="form.controls.dosageUnit"
                label="Dosage Unit"
                placeholder="mg/ml"
                (itemAdded)="dosageUnitAdded($event)"
                #dosageUnit
            >
            </app-autocomplete>
            <app-autocomplete class="autocomplete"
                [data]="dosageForms$ | async" 
                searchKeyword="name"
                [control]="form.controls.dosageForm"
                label="Form"
                placeholder="SOL"
                (itemAdded)="dosageFromAdded($event)"
                #dosageForm
            >
            </app-autocomplete>
            <app-input label="Custom NDC"
                formControlName="ndc"
                placeholder="00000-0000-0"
                inputMask="00000-0000-00"
                tooltipText="Custom NDC is linked to the Package Size and cannot be changed"
                tooltipTextWidth="265"
                (blurred)="ndcInputBlurred()"
            ></app-input>
            <app-input label="Package Size"
                formControlName="packageSize"
                type="number"
                placeholder="60"
                tooltipText="Package size is linked to the Custom NDC and cannot be changed"
                tooltipTextWidth="265"
                (keyupEnter)="handleLastInputKeyEnterTab()"
                (keydownTab)="handleLastInputKeyEnterTab()"
            ></app-input>
        </div>
    </div>

</app-dialog>